import { defineMessages } from 'react-intl';

export default defineMessages({
  threadsToday: {
    id: 'app.features.aiCompanion.threadsToday',
    defaultMessage: 'Today',
  },
  threadsPrevious30Days: {
    id: 'app.features.aiCompanion.threadsPrevious30Days',
    defaultMessage: 'Previous 30 days',
  },
  threadsOlder: {
    id: 'app.features.aiCompanion.threadsOlder',
    defaultMessage: 'Older',
  },
});
